import React, { lazy } from 'react';
import { motion } from 'framer-motion';
const collagePhotos = [{
  src: 'https://cdn.magicpatterns.com/uploads/fDRVPXkFpxRnq4EamRKuZZ/WhatsApp_Image_2026-04-15_at_23.18.19_(3).jpg',
  alt: 'Cliente feliz con ramo de flores',
  rotate: -8,
  delay: 0.2
}, {
  src: 'https://cdn.magicpatterns.com/uploads/4juXc3pqXkPwFxTQoHBfCn/WhatsApp_Image_2026-04-15_at_23.18.19_(2).jpg',
  alt: 'Cliente feliz con globo Feliz Cumpleaños',
  rotate: 5,
  delay: 0.3
}, {
  src: 'https://cdn.magicpatterns.com/uploads/fvTxRFQZyaRHaGD5hWjRgb/WhatsApp_Image_2026-04-15_at_23.18.19_(1).jpg',
  alt: 'Cliente feliz con caja de regalo',
  rotate: -4,
  delay: 0.4
}, {
  src: 'https://cdn.magicpatterns.com/uploads/7Mmjj13b29ASjBgQpwujLY/WhatsApp_Image_2026-04-15_at_23.18.19.jpg',
  alt: 'Cliente feliz con globo Te Amo',
  rotate: 7,
  delay: 0.5
}, {
  src: 'https://cdn.magicpatterns.com/uploads/j4QmpzN4gqvXQoc1Nk8ogT/WhatsApp_Image_2026-04-15_at_23.18.18_(5).jpg',
  alt: 'Desayunos fuera de este mundo',
  rotate: -6,
  delay: 0.6
}, {
  src: 'https://cdn.magicpatterns.com/uploads/vcnznCrxr61eoJEdCBppzj/WhatsApp_Image_2026-04-15_at_23.18.18_(4).jpg',
  alt: 'Cliente feliz con regalo',
  rotate: 4,
  delay: 0.3
}, {
  src: 'https://cdn.magicpatterns.com/uploads/nz5URMXSQHp52piCBx2v7C/WhatsApp_Image_2026-04-15_at_23.18.18_(3).jpg',
  alt: 'Cliente feliz con caja y globo',
  rotate: -9,
  delay: 0.45
}, {
  src: 'https://cdn.magicpatterns.com/uploads/9cB1mY2ZHN18GAFgvpY6kj/WhatsApp_Image_2026-04-15_at_23.18.18_(2).jpg',
  alt: 'Cliente feliz con regalo rosa',
  rotate: 6,
  delay: 0.55
}, {
  src: 'https://cdn.magicpatterns.com/uploads/kmg1zciDENxYC58RQW8MkR/WhatsApp_Image_2026-04-15_at_23.18.18_(1).jpg',
  alt: 'Cliente feliz con globo cumpleaños',
  rotate: -3,
  delay: 0.35
}, {
  src: 'https://cdn.magicpatterns.com/uploads/rL34T2K2g2Hdy9nADWu4zp/WhatsApp_Image_2026-04-15_at_23.18.18.jpg',
  alt: 'Cliente feliz con globo Te Amo',
  rotate: 8,
  delay: 0.5
}, {
  src: 'https://cdn.magicpatterns.com/uploads/h7aP1CiF9e5a3DyQ19kCA4/WhatsApp_Image_2026-04-15_at_23.35.13_(1).jpg',
  alt: 'Cliente feliz con globo Felicidades Papá',
  rotate: -5,
  delay: 0.35
}, {
  src: 'https://cdn.magicpatterns.com/uploads/6wXT7C1ygsotajeeLw2s6f/WhatsApp_Image_2026-04-15_at_23.35.13.jpg',
  alt: 'Cliente feliz con globo Te Quiero',
  rotate: 7,
  delay: 0.45
}, {
  src: 'https://cdn.magicpatterns.com/uploads/bfUp7PPuV9RS5FR812k5Yk/WhatsApp_Image_2026-04-15_at_23.35.12_(1).jpg',
  alt: 'Cliente feliz con globo estrella roja',
  rotate: -4,
  delay: 0.55
}, {
  src: 'https://cdn.magicpatterns.com/uploads/hiysesSHATRLzmnfifeWGm/WhatsApp_Image_2026-04-15_at_23.35.12.jpg',
  alt: 'Graduados felices con sus regalos',
  rotate: 6,
  delay: 0.65
}];
export function Hero() {
  return <section className="relative overflow-hidden bg-brand-blush/30" data-id="element-29">
      {/* Decorative background blobs */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none opacity-20" data-id="element-30">
        <svg className="absolute -top-24 -left-24 w-96 h-96 text-rose-300" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" data-id="element-31">
          <path fill="currentColor" d="M44.7,-76.4C58.8,-69.2,71.8,-59.1,81.3,-46.3C90.8,-33.5,96.8,-18.1,97.1,-2.6C97.4,12.9,92,28.5,82.2,41.1C72.4,53.7,58.2,63.3,43.2,70.6C28.2,77.9,12.4,82.9,-3.1,87.8C-18.6,92.7,-33.8,97.5,-47.4,92.2C-61,86.9,-73,71.5,-81.4,55.1C-89.8,38.7,-94.6,21.3,-93.8,4.4C-93,-12.5,-86.6,-28.9,-76.8,-42.6C-67,-56.3,-53.8,-67.3,-39.6,-74.5C-25.4,-81.7,-10.2,-85.1,3.4,-90.6C17,-96.1,30.6,-83.6,44.7,-76.4Z" transform="translate(100 100)" data-id="element-32" />
        </svg>
        <svg className="absolute -bottom-32 -right-32 w-[30rem] h-[30rem] text-rose-200" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" data-id="element-33">
          <path fill="currentColor" d="M51.8,-69.5C65.5,-59.5,73.8,-42.1,78.8,-24.1C83.8,-6.1,85.5,12.5,78.9,28.8C72.3,45.1,57.4,59.1,40.8,68.1C24.2,77.1,5.9,81.1,-11.5,78.5C-28.9,75.9,-45.4,66.7,-58.5,53.8C-71.6,40.9,-81.3,24.3,-84.6,6.5C-87.9,-11.3,-84.8,-30.3,-74.5,-45.1C-64.2,-59.9,-46.7,-70.5,-30.1,-75.7C-13.5,-80.9,2.2,-80.7,18.5,-76.3C34.8,-71.9,38.1,-79.5,51.8,-69.5Z" transform="translate(100 100)" data-id="element-34" />
        </svg>
      </div>

      {/* Main hero content */}
      <div className="relative z-10 flex flex-col items-center justify-center min-h-[60vh] px-6 pt-20 pb-12" data-id="element-35">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-center space-y-6 max-w-4xl mx-auto" data-id="element-36">
          <span className="inline-block px-4 py-1.5 rounded-full bg-white/60 backdrop-blur-sm border border-rose-100 text-rose-800 text-sm font-medium tracking-widest uppercase mb-4" data-id="element-37">
            Punta Arenas, Chile
          </span>

          <h1 className="text-5xl md:text-7xl font-serif text-brand-dark leading-tight mb-6" data-id="element-38">
            <span className="italic" data-id="element-39">Dulce Despertar</span>{' '}
            <span className="not-italic text-brand-rose" data-id="element-40">PUQ</span>
          </h1>

          <p className="text-xl md:text-2xl text-stone-600 font-light max-w-2xl mx-auto leading-relaxed text-balance" data-id="element-41">
            Desayunos a Domicilio para momentos especiales{' '}
            <span className="inline-block ml-2" data-id="element-42">💐💝🎁</span>
          </p>

          <div className="pt-10" data-id="element-43">
            <motion.a href="https://wa.me/56941832127" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-8 py-4 text-lg font-medium text-white bg-brand-rose hover:bg-rose-500 rounded-full shadow-[0_8px_20px_rgb(212,154,154,0.3)] hover:shadow-[0_8px_25px_rgb(212,154,154,0.5)] transition-all duration-300 hover:-translate-y-1" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} data-id="element-44">
              Haz tu pedido
            </motion.a>
          </div>
        </motion.div>
      </div>

      {/* Photo collage section */}
      <div className="relative z-10 px-4 pb-16 pt-4" data-id="element-45">
        <p className="text-center text-sm text-stone-400 uppercase tracking-widest mb-8 font-medium" data-id="element-46">
          Nuestros clientes felices ✨
        </p>
        <div className="flex flex-wrap justify-center gap-3 md:gap-4 max-w-5xl mx-auto" data-id="element-47">
          {collagePhotos.map((photo, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.7,
          rotate: 0
        }} whileInView={{
          opacity: 1,
          scale: 1,
          rotate: photo.rotate
        }} viewport={{
          once: true
        }} transition={{
          delay: photo.delay,
          duration: 0.5,
          ease: 'easeOut'
        }} className="flex-shrink-0" style={{
          zIndex: index
        }} data-id="element-48">
              <div className="bg-white p-1.5 md:p-2 rounded-sm shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-300 cursor-default" style={{
            transform: `rotate(${photo.rotate}deg)`
          }} data-id="element-49">
                <img src={photo.src} alt={photo.alt} className="w-28 h-36 sm:w-32 sm:h-40 md:w-40 md:h-52 object-cover rounded-sm" loading="lazy" data-id="element-50" />
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}